export const locales = 'vi-VN';

export const baseURL = 'https://servicemix-test.olbius.com/endpoints';